// Servicios de API (fetch helpers y endpoints)
const API_BASE = process.env.REACT_APP_BACKEND_URL || 'https://tvs-api.chatup.pe';

async function jsonFetch(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, options);
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(`${res.status} ${res.statusText} @ ${path}: ${text}`);
  }
  const ct = res.headers.get('content-type') || '';
  if (ct.includes('application/json')) return res.json();
  return res.text();
}

/* ------ Grupos ------ */
export const Pantallas = {
  getGroups: () => jsonFetch('/api/pantallas/grupos'),
  createGroup: (payload) =>
    jsonFetch('/api/pantallas/grupos', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }),
  patchGroup: (id, body) =>
    jsonFetch(`/api/pantallas/grupos/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }),
  deleteGroup: (id) =>
    jsonFetch(`/api/pantallas/grupos/${id}`, {
      method: 'DELETE',
    }),
  getGroupPlaylist: (id, onlyActive = false) =>
    jsonFetch(`/api/pantallas/grupos/${id}/playlist?onlyActive=${onlyActive ? 'true' : 'false'}`),
  addPlaylistItems: (id, items) =>
    jsonFetch(`/api/pantallas/grupos/${id}/playlist`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    }),
  reorderPlaylist: (id, updates) =>
    jsonFetch(`/api/pantallas/grupos/${id}/playlist/reorder`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates }),
    }),
  deletePlaylistItem: (id, videoId) =>
    jsonFetch(`/api/pantallas/grupos/${id}/playlist/${videoId}`, { method: 'DELETE' }),
};

/* ------ TVs ------ */
export const TVs = {
  getTvs: () => jsonFetch('/api/pantallas/tv'),
  createTv: (payload) =>
    jsonFetch('/api/pantallas/tv', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    }),
  patchTv: (id, body) =>
    jsonFetch(`/api/pantallas/tv/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }),
  deleteTv: (id) => jsonFetch(`/api/pantallas/tv/${id}`, { method: 'DELETE' }),
};

/* ------ Media (upload) ------ */
export const Media = {
  upload: async (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return jsonFetch('/api/media/upload', { method: 'POST', body: fd });
  },
};

export { API_BASE, jsonFetch };
